import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../wayfinder'
import apple5ac82b from './apple'
import google723582 from './google'
/**
* @see \App\Http\Controllers\Auth\User\Login\LoginController::create
* @see app/Http/Controllers/Auth/User/Login/LoginController.php:22
* @route '/auth/login'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/auth/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\User\Login\LoginController::create
* @see app/Http/Controllers/Auth/User/Login/LoginController.php:22
* @route '/auth/login'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\User\Login\LoginController::create
* @see app/Http/Controllers/Auth/User/Login/LoginController.php:22
* @route '/auth/login'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\User\Login\LoginController::create
* @see app/Http/Controllers/Auth/User/Login/LoginController.php:22
* @route '/auth/login'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\User\Login\LoginController::store
* @see app/Http/Controllers/Auth/User/Login/LoginController.php:30
* @route '/auth/login'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/auth/login',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\User\Login\LoginController::store
* @see app/Http/Controllers/Auth/User/Login/LoginController.php:30
* @route '/auth/login'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\User\Login\LoginController::store
* @see app/Http/Controllers/Auth/User/Login/LoginController.php:30
* @route '/auth/login'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\User\Login\DemoLoginController::__invoke
* @see app/Http/Controllers/Auth/User/Login/DemoLoginController.php:15
* @route '/auth/login/demo'
*/
export const loginDemo = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: loginDemo.url(options),
    method: 'post',
})

loginDemo.definition = {
    methods: ["post"],
    url: '/auth/login/demo',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\User\Login\DemoLoginController::__invoke
* @see app/Http/Controllers/Auth/User/Login/DemoLoginController.php:15
* @route '/auth/login/demo'
*/
loginDemo.url = (options?: RouteQueryOptions) => {
    return loginDemo.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\User\Login\DemoLoginController::__invoke
* @see app/Http/Controllers/Auth/User/Login/DemoLoginController.php:15
* @route '/auth/login/demo'
*/
loginDemo.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: loginDemo.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\User\Login\LoginAfterOTPController::__invoke
* @see app/Http/Controllers/Auth/User/Login/LoginAfterOTPController.php:19
* @route '/auth/login/login-after-otp'
*/
export const loginAfterOtp = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: loginAfterOtp.url(options),
    method: 'get',
})

loginAfterOtp.definition = {
    methods: ["get","head"],
    url: '/auth/login/login-after-otp',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\User\Login\LoginAfterOTPController::__invoke
* @see app/Http/Controllers/Auth/User/Login/LoginAfterOTPController.php:19
* @route '/auth/login/login-after-otp'
*/
loginAfterOtp.url = (options?: RouteQueryOptions) => {
    return loginAfterOtp.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\User\Login\LoginAfterOTPController::__invoke
* @see app/Http/Controllers/Auth/User/Login/LoginAfterOTPController.php:19
* @route '/auth/login/login-after-otp'
*/
loginAfterOtp.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: loginAfterOtp.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\User\Login\LoginAfterOTPController::__invoke
* @see app/Http/Controllers/Auth/User/Login/LoginAfterOTPController.php:19
* @route '/auth/login/login-after-otp'
*/
loginAfterOtp.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: loginAfterOtp.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\User\Login\GoogleLoginController::google
* @see app/Http/Controllers/Auth/User/Login/GoogleLoginController.php:21
* @route '/auth/login/google'
*/
export const google = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: google.url(options),
    method: 'get',
})

google.definition = {
    methods: ["get","head"],
    url: '/auth/login/google',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\User\Login\GoogleLoginController::google
* @see app/Http/Controllers/Auth/User/Login/GoogleLoginController.php:21
* @route '/auth/login/google'
*/
google.url = (options?: RouteQueryOptions) => {
    return google.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\User\Login\GoogleLoginController::google
* @see app/Http/Controllers/Auth/User/Login/GoogleLoginController.php:21
* @route '/auth/login/google'
*/
google.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: google.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\User\Login\GoogleLoginController::google
* @see app/Http/Controllers/Auth/User/Login/GoogleLoginController.php:21
* @route '/auth/login/google'
*/
google.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: google.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\User\Login\AppleLoginController::apple
* @see app/Http/Controllers/Auth/User/Login/AppleLoginController.php:22
* @route '/auth/login/apple'
*/
export const apple = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: apple.url(options),
    method: 'get',
})

apple.definition = {
    methods: ["get","head"],
    url: '/auth/login/apple',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\User\Login\AppleLoginController::apple
* @see app/Http/Controllers/Auth/User/Login/AppleLoginController.php:22
* @route '/auth/login/apple'
*/
apple.url = (options?: RouteQueryOptions) => {
    return apple.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\User\Login\AppleLoginController::apple
* @see app/Http/Controllers/Auth/User/Login/AppleLoginController.php:22
* @route '/auth/login/apple'
*/
apple.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: apple.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\User\Login\AppleLoginController::apple
* @see app/Http/Controllers/Auth/User/Login/AppleLoginController.php:22
* @route '/auth/login/apple'
*/
apple.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: apple.url(options),
    method: 'head',
})

const login = {
    apple: Object.assign(apple, apple5ac82b),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    loginDemo: Object.assign(loginDemo, loginDemo),
    loginAfterOtp: Object.assign(loginAfterOtp, loginAfterOtp),
    google: Object.assign(google, google723582),
}

export default login